import "./Hero.css";
import thevisualdesigner from "../../Images/Brand/@thevisualdesigner.png";
import whatsapp from "../../Images/Social/Whatsap.png";
import arrow from "../../Images/Social/Arrow.png";
import behance from "../../Images/Social/behance.png";
import heroImg from "../../Images/Brand/AuthorHero.png";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
const Hero = ({ menuBar }) => {
    const [mouse, setMouse] = useState(false);
    const [mouse2, setMouse2] = useState(false);
    // Mouse 1
    function handleMouseIn() {
        setMouse(true);
    }
    function handleMouseOut() {
        setMouse(false);
    }

    const LinkTo = useNavigate();
    return (
        <>
            <div className="heroSection">
                <span className="spanForHeroLeft"></span>
                <span className="spanForHeroLeft1"></span>
                <span className="spanForHeroRight"></span>
                <span style={menuBar ? { backgroundColor: "#2c2c2d", transition: "0.5s" } : { backgroundColor: "#F6F6F6", transition: "0.5s" }} className="spanForHeroRight1"></span>

                <div className="leftHeroSection">
                    <div className="authorInfoHero">
                        <img src={thevisualdesigner} alt="" />
                        <div className="texts">
                            <div className="text">
                                Bhanubhakta_Sapkota
                            </div>
                            <div className="text">
                                Graphic Designer
                            </div>
                        </div>
                    </div>

                    <div className="authorTextHero">
                        <p>
                            <span>Hi, I'm </span>
                            Bhanubhakta<br /> Sapkota,
                            <span> The Visual Designer.</span>
                        </p>

                    </div>

                    <div className="authorTextDesc">
                        I do design, branding, and marketing with purpose - creating visuals that inspire, engage, and elevate brands.
                    </div>


                    <div className="authorContactButtonsHero">
                        <button onClick={() => LinkTo("https://wa.me/9816185204")} className={mouse ? "MouseIn" : "MouseOut"} onMouseEnter={handleMouseIn} onMouseLeave={handleMouseOut}>
                            <div className="btnBackPattern"></div>
                            <div className="text"><span>Lets Talk</span><span>Whatsapp</span></div>
                            <div className="icon"><img src={arrow} alt="" /><img src={whatsapp} alt="" /></div>
                        </button>

                        <div onClick={() => LinkTo("https://www.behance.net/bhanubhsapkota1")} onMouseEnter={() => setMouse2(true)} onMouseLeave={() => setMouse2(false)} className={mouse2 ? "btn btnIn" : "btn btnOut"}>
                            <div className="text"><span>View Work</span><span>Behance</span></div>
                            <div className="popIcon"><img src={behance} alt="" /></div>
                        </div>

                    </div>
                </div>

                <div className="rightHeroSection">
                    <div className="heroImage">
                        <img src={heroImg} alt="The Visual Designer founder Bhanubhakta Sapkota" />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Hero;